import NumberHelpers from "../helpers/NumberHelper";

export default class PaymentController {
  constructor(resource) {
    this._resource = resource;
  }

  async report(beginDate, endDate) {
    let response = null
    try {
      let result = await this._resource(`transactions/report`).get({ datas: { beginDate, endDate } })
      return result
    } catch (error) {
      throw error
    }
  }

  capturePayment(payment) {
    const { creditCardId, amount, clientId, observation, installments, reservaId, transactionType } = payment; 
    const paymentValue = amount.replace(/[., ]/g, '');

    debugger
    return this._resource(`cielo-payment/${creditCardId}`).save({ paymentValue, clientId, observation, installments, reservaId, transactionType })
      .then(res => {
        return res.body
      }, err => {
        throw err
      });
  }

  async getTransactionTypes() {
    return await this._resource('transactions/types').get();
  }

  cancelAuthorization(cancelAuthorization) {
    let clientId = cancelAuthorization.clientId
    return this._resource(`vehicle-requests/cancel-authorization/${cancelAuthorization.payment_cielo_id}`).save({ clientId })
      .then(res => {
        return res.body
      }, err => {
        throw err
      });
  }

  capturePreAuthorization(vehicleRequestId, value, client_id) {
    value = value * 100;
    value = value.toString();

    return this._resource(`cielo-pre-authorization/${vehicleRequestId}`).save({ value, client_id })
      .then(res => {
        return res.body
      }, err => {
        throw err
      });
  }

  async capturePendingPayment(transactionId, clientId, paymentValue) {
    try {
      const paymentInCents = NumberHelpers.convertMoneyToInteger(paymentValue);
      const payment = await this._resource(`cielo-partial-payment`).save({
        transactionId,
        clientId,
        paymentInCents
      });

      return payment;
    } catch (error) {
      throw error;
    }
  }

  async preAuthorizePostponedTransaction(transactionId, data) {
    return this._resource(`transactions/pre-autorize-postponed`).save({ transactionId, data })
      .then(res => {
        return res.body
      }, err => {
        throw err
      });
  }
}